import { JOB_TEMPLETE_TYPES } from "./types"

export const getAllJobTempleteesRequest = (data) => ({
  type: JOB_TEMPLETE_TYPES.GET_ALL_JOB_TEMPLETES_REQUEST,
  payload: data
})

export const getAllJobTempleteesSuccess = (data) => ({
  type: JOB_TEMPLETE_TYPES.GET_ALL_JOB_TEMPLETES_SUCCESS,
  payload: data
})

export const getAllJobTempleteesFailure = (data) => ({
  type: JOB_TEMPLETE_TYPES.GET_ALL_JOB_TEMPLETES_FAIL,
  payload: data
})

export const getSpecificJobTempleteRequest = (data) => ({
  type: JOB_TEMPLETE_TYPES.GET_SPECIFIC_JOB_TEMPLETE_REQUEST,
  payload: data
})

export const getSpecificJobTempleteSuccess = (data) => ({
  type: JOB_TEMPLETE_TYPES.GET_SPECIFIC_JOB_TEMPLETE_SUCCESS,
  payload: data
})

export const getSpecificJobTempleteFailure = (data) => ({
  type: JOB_TEMPLETE_TYPES.GET_SPECIFIC_JOB_TEMPLETE_FAIL,
  payload: data
})

export const createJobTempleteRequest = (data) => ({
  type: JOB_TEMPLETE_TYPES.CREATE_JOB_TEMPLETE_REQUEST,
  payload: data
})

export const createJobTempleteSuccess = (data) => ({
  type: JOB_TEMPLETE_TYPES.CREATE_JOB_TEMPLETE_SUCCESS,
  payload: data
})

export const createJobTempleteFailure = (data) => ({
  type: JOB_TEMPLETE_TYPES.CREATE_JOB_TEMPLETE_FAIL,
  payload: data
})

export const resetCreateTemplate = () => ({
  type: JOB_TEMPLETE_TYPES.RESET_CREATE_TEMPLATE
})

export const updateJobTempleteRequest = (data) => ({
  type: JOB_TEMPLETE_TYPES.UPDATE_JOB_TEMPLETE_REQUEST,
  payload: data
})

export const updateJobTempleteSuccess = (data) => ({
  type: JOB_TEMPLETE_TYPES.UPDATE_JOB_TEMPLETE_SUCCESS,
  payload: data
})

export const updateJobTempleteFailure = (data) => ({
  type: JOB_TEMPLETE_TYPES.UPDATE_JOB_TEMPLETE_FAIL,
  payload: data
})

export const deleteJobTempleteRequest = (data) => ({
  type: JOB_TEMPLETE_TYPES.DELETE_JOB_TEMPLETE_REQUEST,
  payload: data
})

export const deleteJobTempleteSuccess = (data) => ({
  type: JOB_TEMPLETE_TYPES.DELETE_JOB_TEMPLETE_SUCCESS,
  payload: data
})

export const deleteJobTempleteFailure = (data) => ({
  type: JOB_TEMPLETE_TYPES.DELETE_JOB_TEMPLETE_FAIL,
  payload: data
})